export const fetchFormData = (
	method: string,
	url: string,
	data: FormData,
	onProgress: (this: XMLHttpRequestUpload, ev: ProgressEvent<XMLHttpRequestEventTarget>) => any,
) =>
	new Promise(async (resolve, reject) => {
		const xhr = new XMLHttpRequest();
		xhr.responseType = 'blob';

		xhr.onreadystatechange = () => {
			// not done done
			if (xhr.readyState !== 4) {
				return;
			}
			const response = new Response(xhr.response, {
				status: xhr.status,
				statusText: xhr.statusText,
			});
			resolve(response);
		};

		xhr.addEventListener('error', () => {
			reject(new TypeError('Failed to fetch'));
		});

		xhr.upload.addEventListener('progress', onProgress);

		xhr.open(method, url, true);
		xhr.send(data);
	});
